import { supabaseAuth } from '../services/supabase';

export const LOGGING_OUT_KEY = 'leadsme:logging_out';
/** Auto-clear stuck logout guard (e.g. hard-nav aborted mid-flight). */
const LOGGING_OUT_TTL_MS = 30_000;

/** Clears the logout-in-progress guard (must run before a new login can apply auth events). */
export function clearLoggingOutFlag(): void {
  try {
    window.sessionStorage.removeItem(LOGGING_OUT_KEY);
  } catch {
    // ignore
  }
}

export function setLoggingOutFlag(): void {
  try {
    window.sessionStorage.setItem(LOGGING_OUT_KEY, String(Date.now()));
  } catch {
    // ignore
  }
}

export function isLoggingOutFlagSet(): boolean {
  try {
    const raw = window.sessionStorage.getItem(LOGGING_OUT_KEY);
    if (!raw) return false;
    // Legacy boolean flag from older builds
    if (raw === '1') return true;
    const startedAt = Number(raw);
    if (!Number.isFinite(startedAt)) {
      clearLoggingOutFlag();
      return false;
    }
    if (Date.now() - startedAt > LOGGING_OUT_TTL_MS) {
      clearLoggingOutFlag();
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export function purgeSupabaseAuthStorage(): void {
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!k) continue;
      const isSupabaseAuthKey =
        (k.startsWith('sb-') && k.includes('-auth-')) ||
        k.includes('supabase.auth') ||
        k.includes('sb-auth-token');
      if (isSupabaseAuthKey) keysToRemove.push(k);
    }
    for (const k of keysToRemove) {
      localStorage.removeItem(k);
    }
  } catch {
    // ignore
  }
}

export async function safeLocalSignOut(): Promise<void> {
  try {
    // Prefer "local" scope when available (Supabase JS v2)
    await (supabaseAuth.auth as any).signOut({ scope: 'local' });
  } catch {
    try {
      await supabaseAuth.auth.signOut();
    } catch {
      // ignore
    }
  }
}

export function isInvalidRefreshTokenError(err: unknown): boolean {
  const msg = err && typeof err === 'object' && 'message' in err ? String((err as any).message) : String(err);
  // IMPORTANT: be strict here.
  // "JWT expired" is often recoverable via refresh and should NOT trigger a hard logout by itself.
  return (
    msg.includes('Invalid Refresh Token') ||
    msg.includes('Refresh Token Not Found') ||
    msg.includes('AuthApiError: Invalid Refresh Token') ||
    msg.includes('refresh_token_not_found') ||
    msg.includes('invalid_refresh_token')
  );
}


